import { useParams } from "react-router";
import { useVbsConfirmationShowQuery } from "@/services/backend/vbs/confirmations/api/confirmation-api";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { CalculationComponent } from "@/routes/processes/[processId]/vbs/calculations/[calculationId]/calculation/calculation-route";

export function ConfirmationCalculationRoute() {
  const { confirmationId } = useParams();
  const {
    data: confirmation,
    isLoading,
    error,
  } = useVbsConfirmationShowQuery({ id: confirmationId! });

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (isLoading) {
    return null;
  }

  return (
    <CalculationComponent
      calculationId={confirmation!.calculationId}
      disabled={confirmation!.immutable}
    />
  );
}
